import { DocumentSubCategory } from './document-subcategory.enum';

export const mapDocumentSubCategoryToState = {
    // INCOMES only those sybcatecories can be mapped to redux application state
    [DocumentSubCategory.employments]: 'employments',
    [DocumentSubCategory.otherIncomes]: 'others',
    [DocumentSubCategory.pensions]: 'others',
    [DocumentSubCategory.selfEmployed]: 'others'
};
